import styled from '@emotion/styled';
import { Alert } from '@qga/roo-ui/components';
import isEmpty from 'lodash/isEmpty';
import { getPageLabel } from 'lib/pages';
import message from './message';

const StyledAlert = styled(Alert)`
  width: 100%;
  top: 0px;

  min-height: 48px;
  margin: 0;
  font-size: 16px;
  font-weight: bold;

  > div > div {
    justify-content: center;
    > div {
      padding-right: 8px;
    }
  }
`;

const blackListedPageLabels = ['QSS Print View Page'];

const GlobalMessage = () => {
  const pageLabel = getPageLabel();
  const shouldShow = !isEmpty(message) && !blackListedPageLabels.includes(pageLabel);

  if (!shouldShow) {
    return null;
  }

  return (
    <StyledAlert variant="error" role="alert" aria-live="assertive">
      {message}
    </StyledAlert>
  );
};

export default GlobalMessage;
